import React from 'react';
import {useSelector} from 'react-redux';
import {
  selectPlayers,
  selectSelectedUnit,
  selectSuccubesSeductionActions,
  selectUnits
} from "../../../redux/reducers/sharedStateReducer/selectors";
import {getUnitById} from "../../../utils/unit/getUnitById";
import {getPlayerById} from "../../../utils/players/getPlayerById";
import {getNeutralPlayerMock} from "../../../utils/players/getNeutralPlayerMock";
import {getPlayerHexColor} from "../../../utils/players/getPlayerHexColor";
import {SUCCUBES_SEDUCTION_RESULT_COLOR, SUCCUBES_SEDUCTION_SUCCESS_THRESHOLD} from "../../../configs/factions/succubes";
import {MINUS_SIGN} from "../../../constants/text";
import {MaskedIcon} from '../../coloredIcons/MaskedIcon/MaskedIcon';
import {
  CombatDuel,
  CombatEquation,
  CombatOperator,
  CombatPanel,
  CombatTerm,
  CombatTotal,
  CombatUnitToken,
  CombatVerdict,
  getCombatUnitIconProps,
} from "../CombatPanel/CombatPanel";

// Панель формулы попытки соблазнения - по образцу SelectedUnitMelee (CombatPanel),
// но без кнопок
// управления (у соблазнения нет reroll/приоритетной цели) и с другой цветовой
// раскладкой: бросок и численность суккуба - цветом суккуба, численность цели -
// цветом её владельца на момент попытки (previousOwner). Показывается ЛЮБОМУ
// игроку, кликнувшему по юниту, который уже пытался соблазнить в этом этапе -
// см. design.md Decision 13. Формула строится из уже сохранённых полей записи
// (roll/attackerSize/targetSize/success), а не пересчитывается из текущего
// состояния юнитов, т.к. численность отрядов на момент попытки могла с тех пор измениться
const SelectedUnitSeduction = () => {
  const selectedUnit = useSelector(selectSelectedUnit);
  const succubesSeductionActions = useSelector(selectSuccubesSeductionActions);
  const players = useSelector(selectPlayers);
  const units = useSelector(selectUnits);

  if (!selectedUnit) return null;

  const seductionActions = succubesSeductionActions.filter(action => action.unitId === selectedUnit.id);
  const seductionAction = seductionActions[seductionActions.length - 1];
  if (!seductionAction) return null;

  const {targetUnitId, previousOwnerId, roll, attackerSize, targetSize, success} = seductionAction;

  const targetUnit = getUnitById(units, targetUnitId);
  const neutralPlayerMock = getNeutralPlayerMock();
  const previousOwner = getPlayerById(players, previousOwnerId) || neutralPlayerMock;
  const result = roll + attackerSize - targetSize;
  const enemyColor = previousOwner.id !== neutralPlayerMock.id ? getPlayerHexColor(previousOwner.color) : null;

  return (
    <CombatPanel
      key={selectedUnit.id}
      toneColor={SUCCUBES_SEDUCTION_RESULT_COLOR}
      duel={(
        <CombatDuel
          actor={<CombatUnitToken unitType={selectedUnit.type} iconProps={getCombatUnitIconProps(selectedUnit, players)}/>}
          actionIcon={<MaskedIcon src={'/img/icons/ability.png'} alt={'Соблазнение'} title={'Соблазнение'} color={SUCCUBES_SEDUCTION_RESULT_COLOR}/>}
          targets={targetUnit ? [(
            <CombatUnitToken
              key={targetUnit.id}
              unitType={targetUnit.type}
              iconProps={{playerColor: previousOwner.color, factionId: targetUnit.factionId, hasUnitSkin: previousOwner.hasUnitSkin}}
              isTarget={true}
            />
          )] : []}
        />
      )}
    >
      <CombatEquation>
        <CombatTerm value={roll} icon={'/img/icons/cube.png'} iconAlt={'Бросок'} color={SUCCUBES_SEDUCTION_RESULT_COLOR} title={'Бросок кости'}/>
        <CombatOperator>{'+'}</CombatOperator>
        <CombatTerm value={attackerSize} icon={'/img/icons/unit size.png'} iconAlt={'Размер'} color={SUCCUBES_SEDUCTION_RESULT_COLOR} title={'Размер отряда суккубов'}/>
        <CombatOperator>{MINUS_SIGN}</CombatOperator>
        <CombatTerm value={targetSize} icon={'/img/icons/unit size.png'} iconAlt={'Размер'} color={enemyColor} title={'Размер цели'}/>
      </CombatEquation>

      <CombatTotal value={result} hint={`нужно ${SUCCUBES_SEDUCTION_SUCCESS_THRESHOLD}+`}/>

      <CombatVerdict isSuccess={success}>
        {success ? 'Успех — отряд соблазнён!' : 'Неудача'}
      </CombatVerdict>
    </CombatPanel>
  );
};

export default SelectedUnitSeduction;
